import { AddonCard } from "../components/AddonCard"
import type { CheckoutViewModel } from "../viewTypes"

type Props = Pick<CheckoutViewModel,
    "navigateWorkflow" | "meta" | "product" | "selectedAddonIds" | "toggleAddon" | "analytics" | "error" | "addonsDisabled" | "continueFromAddons" | "addonContinueLabel"> & { product: NonNullable<CheckoutViewModel["product"]> }

export function AddonsStep(inputs: Props) {
    const {
        navigateWorkflow,
        meta,
        product,
        selectedAddonIds,
        toggleAddon,
        analytics,
        error,
        addonsDisabled,
        continueFromAddons,
        addonContinueLabel,
    } = inputs
    return (
        <section className="ah-panel ah-stage-panel ah-addons-panel">
            <button type="button" className="ah-addons-back" onClick={() => navigateWorkflow("dates")}>
                <span aria-hidden="true">←</span> Back to dates and equipment
            </button>
            <header className="ah-addons-heading">
                <h2>Booking Add-ons</h2>
                <p>{meta.type === "portable-ac" ? "Make your space comfortable with these optional extras." : "Optional add-ons to help you get the job done."}</p>
            </header>
            {product.accessories.length > 0 ? (
                <div className="ah-addons-grid">
                    {product.accessories.map((addon) => (
                        <AddonCard
                            key={addon.id}
                            addon={addon}
                            selected={selectedAddonIds.includes(addon.id)}
                            onToggle={() => toggleAddon(addon)}
                            onImageExpand={() => analytics("hire_addon_images_viewed", { addon_slug: addon.slug })}
                        />
                    ))}
                </div>
            ) : (
                <p className="ah-addons-empty">No add-ons are currently available for this equipment.</p>
            )}
            {error && <div className="ah-alert ah-error" role="alert">{error}</div>}
            <button type="button" className="ah-primary-button ah-stage-action" disabled={addonsDisabled} onClick={() => void continueFromAddons()}>{addonContinueLabel}</button>
        </section>
    )
}
